import type { RouteLocation, RouteRecordRaw } from "vue-router";

/*
 * The old "create-new" card renewal route now REDIRECTS to the guarded
 * card-renewal-create route instead of rendering NewCreate.vue.
 *
 * NewCreate.vue is an unfinished stub (its API calls are commented out) and
 * nothing in the app links to it, but the route was still reachable by URL and
 * rendered a renewal form with no eligibility check. Redirecting sends anyone
 * who lands here through Create.vue's gate, so a refused applicant sees the
 * local-office notice. The route name is kept so a stray link still resolves,
 * and the query is carried over so a pending_app link keeps its draft.
 */
export const cardRenewalCreateNewRoute: RouteRecordRaw = {
  path: "create-new",
  name: "card-renewal-create-new",
  redirect: (to: RouteLocation) => ({
    name: "card-renewal-create",
    query: to.query,
  }),
};
